module.exports = __webpack_public_path__ + "img/button.25648125.png";